import {
  BancoHistoricosSchema,
  BancoMovimientoListQuerySchema,
  BancoMovimientoMergedSchema,
  BancoMovimientoSchema,
  BancoSaldoSchema,
  CreateBancoMovimientoRequestSchema,
  UpdateBancoMovimientoRequestSchema,
} from '@visep/shared-types/banco';
import type {
  BancoHistoricos,
  BancoMovimientoListQuery,
  BancoMovimientoMerged,
  BancoSaldo,
} from '@visep/shared-types/banco';
import type { Helpers, ListResult } from './internal.js';
import { listResultSchema, makeCrudResource, toQuery } from './internal.js';

const movimientosMergedListSchema = listResultSchema(BancoMovimientoMergedSchema);

export function createBancoResource({ request }: Helpers) {
  const movimientos = makeCrudResource(request, {
    basePath: '/api/banco/movimientos',
    schema: BancoMovimientoSchema,
    listQuerySchema: BancoMovimientoListQuerySchema,
    createSchema: CreateBancoMovimientoRequestSchema,
    updateSchema: UpdateBancoMovimientoRequestSchema,
  });
  return {
    async getSaldo(): Promise<BancoSaldo> {
      return BancoSaldoSchema.parse(await request('GET', '/api/banco/saldo'));
    },
    async getHistoricos(query?: { from?: string; to?: string }): Promise<BancoHistoricos> {
      return BancoHistoricosSchema.parse(await request('GET', `/api/banco/historicos${toQuery(query ?? {})}`));
    },
    // A-2: a lista é a vista unificada (movimientos + transferencias com perna banco).
    async listMovimientos(query?: BancoMovimientoListQuery): Promise<ListResult<BancoMovimientoMerged>> {
      const parsed = BancoMovimientoListQuerySchema.parse(query ?? {}) as Record<string, unknown>;
      return movimientosMergedListSchema.parse(
        await request('GET', `/api/banco/movimientos${toQuery(parsed)}`),
      );
    },
    getMovimiento: movimientos.get,
    createMovimiento: movimientos.create,
    updateMovimiento: movimientos.update,
    deleteMovimiento: movimientos.delete,
  };
}
